import { DATOS_REPORTE, LOCALES, REPORTE_PRODUCTOS, REPORTE_PROVEEDORES } from '../constants';
import Axios from '../extras/Axios';

export async function obtenerDatosParaReporte(from, to, local) {
  const respuesta = await Axios.post(DATOS_REPORTE, { from, to, local });
  if (respuesta.status !== 200) return [];
  const datos = await respuesta.data;
  return datos;
}

export async function obtenerCantProveedores(fromDate, toDate) {
  const respuesta = await Axios.post(REPORTE_PROVEEDORES, { fromDate, toDate });
  if (respuesta.status !== 200) return 0;
  return respuesta.data;
}

export async function obtenerCantProductos(fromDate, toDate) {
  const respuesta = await Axios.post(REPORTE_PRODUCTOS, { fromDate, toDate });
  if (respuesta.status !== 200) return { vendidos: 0, stock: 0 };
  return respuesta.data;
}

export async function obtenerLocales() {
  try {
    return (await Axios.get(LOCALES)).data;
  } catch (error) {
    return [];
  }
}